

import React, { forwardRef } from 'react';


import PlayerComponent from '../components/Player';
import { UploaderConsumer, AssetSelector } from '../../Uploader';
import { CommentsConsumer } from '../../Comments';
import RequestProvider from '../../RequestProvider';
import { getBynderAssetDownloadUrl as getBynderAssetDownloadUrlApi } from '../../../common/api';



















const PlayerContainer = (
{ assetId, sceneId, shotId, analyticsResourceId, ...props },
ref) =>

<UploaderConsumer>
    {({ subscribeToAssetTranscoded }) =>
  <AssetSelector assetId={assetId}>
        {(asset) =>
    <CommentsConsumer>
            {({ state: { commentModalId, selectedComment } = {} }) =>
      <RequestProvider requests={{
        getBynderAssetDownloadUrl: getBynderAssetDownloadUrlApi()
      }}>

                {(requests) =>
        <PlayerComponent
          {...props}
          ref={ref}
          assetId={assetId}
          asset={asset}
          commentModalId={commentModalId}
          analyticsResourceId={analyticsResourceId}
          subscribeToAssetTranscoded={subscribeToAssetTranscoded}
          sceneId={sceneId}
          shotId={shotId}
          selectedComment={selectedComment}
          {...requests} />}


              </RequestProvider>}

          </CommentsConsumer>}

      </AssetSelector>}

  </UploaderConsumer>;


export default forwardRef(PlayerContainer);